<template>
    <div v-html="html"></div>
</template>

<script>
const styleOrEmpty = (value, name) => (value ? `${name}:${value};` : '');

export const buildDefaultHtml = (props = {}) => {
    const content = props.content || '';
    const color = styleOrEmpty(props.color, 'color');
    const fontSize = styleOrEmpty(props.fontSize, 'font-size');
    const fontFamily = styleOrEmpty(props.fontFamily, 'font-family');
    const lineHeight = styleOrEmpty(props.lineHeight, 'line-height');
    const align = styleOrEmpty(props.align, 'text-align');
    const padding = styleOrEmpty(props.padding, 'padding');
    return `<div style="${align}${padding}"><p style="margin:0;${color}${fontSize}${fontFamily}${lineHeight}">${content}</p></div>`;
};

export default {
    name: 'MailingBlockText',
    props: {
        html: { type: String, default: '' },
    },
};
</script>
